module.exports.SVERD = 'sverd';
module.exports.ORENB = 'orenb';
module.exports.ORLOV = 'orlov';
module.exports.HMAO = 'hmao';
module.exports.KRASN = 'krasn';
module.exports.KALUG = 'kalug';
module.exports.LITVA = 'litva';
module.exports.KAREL = 'karel';
module.exports.SAAS = 'saas';
module.exports.TATAR = 'tatar';
module.exports.MARIEL = 'mariel';
module.exports.KURGAN = 'kurgan';
module.exports.CHUVA = 'chuva';
module.exports.BURYATIA = 'buryatia';
module.exports.CHECHNYA = 'chechnya';
module.exports.YANAO = 'yanao';
module.exports.CRIMEA = 'crimea';
module.exports.KURSK='kursk';
module.exports.PSCOV = 'pscov';
